import { createUserManager } from "redux-oidc";
import { loadUser } from "redux-oidc";
import getUrls from "../api";
export const ANONYMOUS_MODE = "AnonymousMode";
let _userManager;

const settings = {
    client_id: "webStdEcgReport", //"spa_react", //
    // redirect_uri: `${root}/authentication/callback`,
    response_type: "code",
    // post_logout_redirect_uri: `${root}/authentication/signoutCallback`,
    scope: "openid profile email roles webOrgsUsersDataApi webCardiographReportsApi offline_access display_name kernelApi", // kernelApi
    authority: "https://localhost", //'https://identity.incart.ru' //'http://identity.incart.ru:7050',//
    // silent_redirect_uri: `${root}/silent_renew.html`,
    automaticSilentRenew: true, // продление токена — через refresh_token (offline_access), без iframe
    // monitorSession=false: его check_session iframe на кросс-хосте (SPA ≠ хост Identity, напр.
    // localhost vs yes-nuc2) терял сторонний cookie и каждые ~2 сек ложно выкидывал из сессии.
    // Подробности и требования сервера — README, раздел «ОТЛАДКА DEV ЗА NGINX И ВХОД (OIDC)».
    monitorSession: false,
    loadUserInfo: true,
    triggerAuthFlow: true
};

// Load Identity server host and create usermanager
export const createManager = async (store, basepath) => {
    let root = window.location.origin;
    if (!root.endsWith("/")) root += "/";
    if (basepath) {
        root += basepath + "/";
    }

    settings.redirect_uri = `${root}authentication/callback`;
    settings.post_logout_redirect_uri = `${root}authentication/signoutCallback`;
    settings.silent_redirect_uri = `${root}silent_renew.html`;
    const { urlGetIdentityServerHost } = getUrls(basepath);
    const identitySettings = await fetch(urlGetIdentityServerHost)
        .then(resp => {
            return resp.json();
        })
        .then(res => {
            if (res) {
                settings.authority = res.host;
                settings.scope += " " + res.scope;
            } else throw Error("");
            return res;
        })
        .catch(err => {
            console.error("Couldn't fetch identity server host: " + urlGetIdentityServerHost);
            console.error(err);
            console.log("Using default identity server host"); // eslint-disable-line
        });

    // Check Anonymous mode
    if (identitySettings?.AnonymousMode) {
        _userManager = {
            mode: ANONYMOUS_MODE,
            useCloseAppByFile: identitySettings.UseCloseAppByFile
        };
        return _userManager;
    }

    _userManager = createUserManager(settings);
    loadUser(store, _userManager);
    return _userManager;
};

const getUserManager = () => _userManager;
export default getUserManager;
